import { supabase } from '@/integrations/supabase/client';
import type {
  ContentMetricsScraperPort,
  ScrapeMetricsResponse,
} from '../ports/contentScraper.port';

export class ApifyMetricsScraper implements ContentMetricsScraperPort {
  async scrapePostMetrics(submissionId: string): Promise<ScrapeMetricsResponse> {
    const response = await supabase.functions.invoke<ScrapeMetricsResponse>(
      'scrape-post-metrics',
      {
        body: { submission_id: submissionId },
      }
    );

    if (response.error) {
      let errorDetail = response.error.message;
      try {
        if ('context' in response.error && response.error.context) {
          const res = response.error.context as Response;
          const errorBody = await res.json();
          errorDetail =
            errorBody.details ||
            errorBody.error ||
            errorBody.message ||
            response.error.message;
        }
      } catch {
        // ignore JSON parse failure
      }
      throw new Error(errorDetail || "We couldn't start fetching post metrics. Please try again.");
    }

    return response.data || { status: 'success' };
  }
}

export const apifyMetricsScraper = new ApifyMetricsScraper();
